<template>
  <b-col v-if="openPlan" class="pricing-info-container justify-content-center">
    <div class="d-flex flex-column">
      <div class="title">{{ openPlan.name }}</div>
      <div class="subtitle">{{ openPlan.description }}</div>
      <div class="frequency">{{ chargeFrequencyText }}</div>
      <div class="divider d-none d-md-block"></div>
      <p class="contact-text d-none d-md-block">
        {{ $t('purchase.price.info.contactUs') }}
        <a href="mailto:info@vexels.com">info@vexels.com</a>
        {{ $t('purchase.price.info.liveChat') }}
      </p>
      <div class="divider d-none d-md-block"></div>
      <div class="gray-text terms-and-cond d-none d-md-block">
        <p>
          {{ $t('purchase.price.info.subscriptionRenew') }}
        </p>
        <p>
          <span class="gray-text">{{ $t('purchase.price.info.byPurchasing') }}</span>
          <nuxt-link :to="$trailingSlash(localePath('terms-and-conditions'))">{{
            $t('purchase.price.info.termsAndConditions')
          }}</nuxt-link>
        </p>
      </div>

      <div class="divider"></div>
      <div class="row">
        <div class="col-sm-6 total-due">{{ $t('purchase.price.info.totalDue') }}</div>
        <div class="col-sm-6 price">
          <span class="currency">$</span><span class="amount">{{ openPlan.originalCost }}</span>
        </div>
      </div>
    </div>
  </b-col>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState('plans', ['openPlan']),
    chargeFrequencyText() {
      const frequency = this.openPlan.chargeFrecuency;
      return frequency === 'ANNUALLY'
        ? this.$t('purchase.price.info.billedAnnually')
        : frequency === 'MONTHLY'
        ? this.$t('purchase.price.info.billedMonthly')
        : frequency === 'LIFETIME'
        ? this.$t('purchase.price.info.billedOneTime')
        : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.pricing-info-container {
  padding: 15px 25px;
  @include lg {
    padding: 30px;
  }
  .title {
    font-weight: 500;
    font-size: 25px;
    margin-bottom: 15px;
  }
  .subtitle {
    font-size: 13px;
  }
  .frequency {
    font-size: 12px;
    margin-bottom: 20px;
    margin-top: 15px;
    color: #b5b5b5;
  }
  .contact-text {
    font-size: 13px;
  }
  .divider {
    border-top: 2px solid #f1f1f1;
    padding: 10px 0;
  }
  .gray-text {
    color: #b5b5b5;
  }
  .terms-and-cond {
    font-size: 12px;
  }
  .price {
    font-size: 32px;
    text-align: right;
  }
  .total-due {
    font-size: 15px;
    display: flex;
    align-items: center;
  }
  .amount {
    font-weight: 500;
  }
  .currency {
    font-size: 20px;
  }
}
</style>
